<template>
    <div class="container-fluid">
        <BroshureModal/>
        <Navbar/>
        <Slider/>
        <Info/>
        <Card
                id="architettura"
                title="Architettura"
                icon-name="compax.png"
                image-name="Sezione_Architettura.jpg"
                text="Non solo render di esterni e di interni curati nei minimi dettagli, ma anche
                    tour virtuali a 360°, planivolumetrici e piantine in 3D e, non per ultima, la
                    visita interattiva del cantiere con la realtà virtuale.
                    Un pacchetto di servizi per offrire ai nostri clienti la soluzione ottimale per
                    comunicare al meglio il loro progetto architettonico."
                :overlap-top="true"
        />
        <Card
                id="design"
                title="Design"
                icon-name="pencil.png"
                image-name="Sezione_Design.jpg"
                text="Realizziamo immagini uniche ed originali dei tuoi prodotti ambientati in
                quasiasi tipo di location, allestimenti virtuali dove cambiare velocemente
                colori e finiture, video emozionali e video istruzioni 3D.
                Con il configuare 3D offriamo uno strumento innovativo per una visione
                interattiva dei prodotti."
                :overlap-top="false"
                :text-right="true"
        />
        <Card
                id="industria"
                title="Industria"
                icon-name="machine.png"
                image-name="Sezione_Industria.jpg"
                text="Realizziamo render per cataloghi e video istruzioni di funzionamento delle
                        macchine e degli impianti industriali.
                        Con le più avanzate tecniche di virtualizzazione costruiamo cataloghi in
                        realtà virtuale per presentare i prodotti che non si possono vedere dal
                        vivo."
                :overlap-top="true"
                :text-right="false"
        />
        <div id="gallery" class="row py-4 text-center mx-0">
            <div class="row m-auto py-2 btn-container">
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray my-1" v-on:click="category = 1">Architettura</button>
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray px-4 my-1" v-on:click="category = 2">Design</button>
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray px-4 my-1" v-on:click="category = 3">Industria</button>
                </div>
            </div>
        </div>
        <Gallery v-if="category === 1" :image-urls="archMedias"/>
        <Gallery v-else-if="category === 2" :image-urls="designMedias"/>
        <Gallery v-else-if="category === 3" :image-urls="industriaMedias"/>
        <div class="row py-4 text-center mx-0">
            <div class="row m-auto py-2 btn-container">
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray my-1" v-on:click="category = 1">Architettura</button>
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray px-4 my-1" v-on:click="category = 2">Design</button>
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-block button-gray px-4 my-1" v-on:click="category = 3">Industria</button>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Navbar from "../components/Navbar";
    import Slider from "../components/Slider";
    import Info from "../components/InfoSection";
    import Card from "../components/Card";
    import Gallery from "../components/Gallery";
    import Footer from "../components/Footer";
    import BroshureModal from "../components/BroshureModal";

    export default {
        name: 'Home',
        components: {
            BroshureModal,
            Footer,
            Gallery,
            Card,
            Info,
            Slider,
            Navbar
        },
        data() {
            return {
                category: 1,
                archMedias: [
                    'ARCH_01.jpg',
                    'ARCH_02.jpg',
                    'ARCH_03.jpg',
                    'ARCH_04.jpg',
                    'ARCH_05_video.jpg',
                    'ARCH_06.jpg',
                    'ARCH_07.jpg',
                    'ARCH_08.jpg',
                    'ARCH_09.jpg',
                    'ARCH_10.jpg',
                ],
                designMedias: [
                    'DESIGN_01.jpg',
                    'DESIGN_02_video.jpg',
                    'DESIGN_03.jpg',
                    'DESIGN_04.jpg',
                    'DESIGN_05.jpg',
                    'DESIGN_06.jpg',
                    'DESIGN_07.jpg',
                    'DESIGN_08.jpg',
                    'DESIGN_09.jpg',
                    'DESIGN_10_video.jpg',
                ],
                industriaMedias: [
                    'INDUSTRIA_01.jpg',
                    'INDUSTRIA_02.jpg',
                    'INDUSTRIA_03.jpg',
                    'INDUSTRIA_04.jpg',
                    'INDUSTRIA_05_video.jpg',
                    'INDUSTRIA_06.jpg',
                    'INDUSTRIA_07.jpg',
                    'INDUSTRIA_08.jpg',
                    'INDUSTRIA_09_video.jpg',
                    'INDUSTRIA_10.jpg',
                ]
            }
        }
    }
</script>
